import React from "react";
import { UploaderSideBar } from "../UploaderComponent/UploaderSideBar.js";

const MobileUploaderSecondPage = ({ setCurrentRecipients }) => {
  return (
    <div className="mobile-uploader-second-page">
      <UploaderSideBar setCurrentRecipients={setCurrentRecipients} />
    </div>
  );
};

export default MobileUploaderSecondPage;
